export interface ServiceRequestChannelVisibility {
  showSend: boolean;
  showBoutique: boolean;
}

export function resolveServiceRequestChannels(input: {
  ecsAvailable: boolean;
  serviceRequestEnabled: boolean;
}): ServiceRequestChannelVisibility {
  const showSend = input.ecsAvailable && input.serviceRequestEnabled;
  return {
    showSend,
    showBoutique: true,
  };
}
